import React from "react";
import bodyParts from "../data/bodyParts";

const SelectSymptom = ({ selectedPart, setSelectedSymptom }) => {
  return (
    <div>
      <label>症状を選択してください:</label>
      <select onChange={(e) => setSelectedSymptom(e.target.value)}>
        <option value="">-- 選択してください --</option>
        {bodyParts[selectedPart].map((symptom) => (
          <option value={symptom} key={symptom}>
            {symptom}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectSymptom;
